<template>
    <ClientOnly>
        <VJoyIconButton
            class="wishlist"
            :icon="wishlistIcon"
            variant="primary"
            size="xxsmall"
            data-testid="profile-view-header-wishlist-cta"
            @click="editWishlist"
        />
        <VJoyIconButton
            class="wishlist-mobile"
            :icon="wishlistIcon"
            variant="primary"
            size="small"
            data-testid="profile-view-header-wishlist-cta-mobile"
            @click="editWishlist"
        />
        <ExternalUserActionWishlist />
        <ExternalUserActionAddWishlist />
        <template #fallback>
            <VJoyFormFieldSkeleton class="wishlist" size="xxsmall" width="24px" />
            <VJoyFormFieldSkeleton class="wishlist-mobile" size="small" width="40px" />
        </template>
    </ClientOnly>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {computed, useProfileTracking} from '#imports';
    import {type TJoyIconsNames, VJoyIconButton, VJoyFormFieldSkeleton} from '@maltjoy/core-vue';
    import ExternalUserActionAddWishlist from '~/components/external-user-action/wishlist/ExternalUserActionAddWishlist.vue';
    import ExternalUserActionWishlist from '~/components/external-user-action/wishlist/ExternalUserActionWishlist.vue';
    import {eventBus} from '~/config/events';
    import {useProfileStore} from '~/store/profileStore';
    import {useWishlistStore} from '~/store/wishlist/wishlistStore';

    const {profile} = storeToRefs(useProfileStore());
    const {wishlists} = storeToRefs(useWishlistStore());
    const {trackWishListOpened} = useProfileTracking();

    const wishlistIcon = computed<TJoyIconsNames>(() => {
        const hasProfileInWishlist = wishlists.value.items.some((wishlist) => wishlist.profiles.includes(profile.value!.profileId));
        return hasProfileInWishlist ? 'heart-fill' : 'heart';
    });

    function editWishlist() {
        trackWishListOpened(profile.value?.accountId);
        eventBus.emit('wishlist:edit-mode');
    }
</script>
<style lang="scss" scoped>
    .wishlist {
        position: absolute;
        top: var(--joy-core-spacing-2);
        left: var(--joy-core-spacing-2);
    }

    .wishlist-mobile {
        display: none;

        position: absolute;
        top: var(--joy-core-spacing-2);
        right: var(--joy-core-spacing-2);
    }

    @container profile-header-section (max-width: 750px) {
        .wishlist {
            display: none;
        }
        .wishlist-mobile {
            display: block;
        }
    }
</style>
